<template>
  <div class="table-box">
    <table
      width="100%"
      cellpadding="0"
      cellspacing="0"
      style="table-layout: fixed; border-collapse: separate;"
    >
      <colgroup>
        <col span="4">
        <col width="80">
      </colgroup>
      <tr valign="top">
        <td>
          <slot name="A1">A1</slot>
        </td>
        <td>
          <slot name="B1">B1</slot>
        </td>
        <td>
          <slot name="C1">C1</slot>
        </td>
        <td>
          <slot name="D1">D1</slot>
        </td>
        <td>
          <slot name="E1">E1</slot>
        </td>
      </tr>
      <tr valign="top">
        <td rowspan="2">
          <slot name="A2">A2</slot>
        </td>
        <td class="no-border upper">
          <slot name="B2">B2</slot>
        </td>
        <td class="no-border upper">
          <slot name="C2">C2</slot>
        </td>
        <td class="no-border upper">
          <slot name="D2">D2</slot>
        </td>
        <td rowspan="2">
          <slot name="E2">E2</slot>
        </td>
      </tr>
      <tr valign="top">
        <td class="lower">
          <slot name="B3">B3</slot>
        </td>
        <td class="lower">
        </td>
        <td class="lower">
        </td>
      </tr>
      <tr valign="top">
        <td>
          <slot name="A4">A4</slot>
        </td>
        <td colspan="3">
          <slot name="B4">B4</slot>
        </td>
        <td>
          <slot name="E4"></slot>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.table-box {
  width: 100%;
  padding: 0 20px 20px 20px;
  background-color: #fff;
  border-radius: 6px;
  box-sizing: border-box;
  margin: 20px 0;
}
.table-box td {
  padding: 20px 0;
  box-sizing: border-box;
  background-color: transparent;
  border-bottom: 1px solid #f2f2f2;
}
.table-box td.no-border {
  border-bottom: none;
}
.table-box td.upper {
  padding-bottom: 0;
}
.table-box td.lower {
  padding-top: 0;
}
.table-box tr:last-child td {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/views/userInfo/components/tableFrame.vue